import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

export const StatusChip = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(status)}
      sx={{
        float: "right",
        backgroundColor:
          status === "completed"
            ? "#4CAF50"
            : status === "assigned"
            ? "#FFC107"
            : status === "out_of_service"
            ? "#F44336"
            : "#007bff",
        color: "white",
      }}
    />
  );
};
